(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sections = document.querySelectorAll('[data-reinheit-scroll]');

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function init(section) {
    if (section.getAttribute('data-rs-initialized') === 'true') return;
    section.setAttribute('data-rs-initialized', 'true');

    if (section.getAttribute('data-rs-mode') === 'sequence') {
      initSequence(section);
      return;
    }

    if (reduceMotion.matches) return;

    var url = section.getAttribute('data-video-url');
    var sticky = section.querySelector('.rs-sticky');
    var overlay = section.querySelector('.rs-overlay');
    if (!url || !sticky) return;

    var video = null;
    var duration = 0;
    var currentProgress = 0;
    var targetProgress = 0;
    var frameRequest = 0;
    var nearby = false;
    var loadingBlob = false;
    var usingBlob = false;
    var objectUrl = '';

    function progressForPosition() {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var denominator = rect.height - viewportHeight;
      if (denominator <= 0) return rect.top <= 0 ? 1 : 0;
      return clamp(-rect.top / denominator, 0, 1);
    }

    function updateOverlay(progress) {
      if (!overlay) return;
      overlay.style.opacity = String(clamp((0.22 - progress) / 0.12, 0, 1));
    }

    function tick() {
      frameRequest = 0;
      if (!nearby) return;

      targetProgress = progressForPosition();
      currentProgress += (targetProgress - currentProgress) * 0.18;
      updateOverlay(targetProgress);

      if (video && duration && !video.seeking) {
        var targetTime = clamp(currentProgress, 0, 1) * duration;
        if (Math.abs(video.currentTime - targetTime) >= 0.02) {
          try {
            video.currentTime = targetTime;
          } catch (error) {
            // The next animation frame retries after the media becomes seekable.
          }
        }
      }

      frameRequest = window.requestAnimationFrame(tick);
    }

    function startLoop() {
      if (frameRequest) return;
      currentProgress = progressForPosition();
      targetProgress = currentProgress;
      updateOverlay(currentProgress);
      frameRequest = window.requestAnimationFrame(tick);
    }

    function stopLoop() {
      if (!frameRequest) return;
      window.cancelAnimationFrame(frameRequest);
      frameRequest = 0;
    }

    function loadBlobFallback() {
      if (loadingBlob || usingBlob) return;
      loadingBlob = true;
      console.info('reinheit-scroll: blob fallback');

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Video request failed');
          return response.blob();
        })
        .then(function (blob) {
          objectUrl = URL.createObjectURL(blob);
          usingBlob = true;
          loadingBlob = false;
          video.src = objectUrl;
        })
        .catch(function () {
          loadingBlob = false;
        });
    }

    function createVideo() {
      if (video) return;

      video = document.createElement('video');
      video.className = 'rs-video';
      video.muted = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      video.addEventListener('loadedmetadata', function () {
        if (!usingBlob && (!video.seekable.length || video.seekable.end(0) <= 0)) {
          loadBlobFallback();
          return;
        }

        duration = isFinite(video.duration) ? video.duration : 0;
        currentProgress = progressForPosition();
        targetProgress = currentProgress;

        if (duration && !video.seeking) {
          try {
            video.currentTime = clamp(currentProgress, 0, 1) * duration;
          } catch (error) {
            // The rAF loop will retry.
          }
        }
      });

      video.addEventListener('error', function () {
        if (!usingBlob) loadBlobFallback();
      });

      video.addEventListener('seeked', function () {
        video.classList.add('is-painted');
      }, { once: true });

      document.addEventListener('touchstart', function () {
        var playAttempt = video.play();
        video.pause();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function () {});
        }
      }, { once: true, passive: true });

      window.addEventListener('pagehide', function () {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
      }, { once: true });

      sticky.insertBefore(video, overlay || null);
      video.src = url;
    }

    var observer = new IntersectionObserver(function (entries) {
      nearby = entries[0].isIntersecting;

      if (nearby) {
        createVideo();
        startLoop();
      } else {
        stopLoop();
      }
    }, { rootMargin: '150% 0px' });

    observer.observe(section);
  }

  function initSequence(section) {
    var steps = section.querySelectorAll('[data-rs-step]');
    var nearby = false;
    var frameRequest = 0;

    function showAll() {
      section.classList.remove('rs-seq-armed');
      for (var index = 0; index < steps.length; index += 1) {
        steps[index].classList.add('is-visible');
      }
    }

    function update() {
      frameRequest = 0;
      if (!nearby || reduceMotion.matches) return;

      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var progress = clamp((viewportHeight - rect.top) / rect.height, 0, 1);

      for (var index = 0; index < steps.length; index += 1) {
        if (progress >= (index + 1) / (steps.length + 1)) {
          steps[index].classList.add('is-visible');
        }
      }
    }

    function requestUpdate() {
      if (frameRequest || !nearby) return;
      frameRequest = window.requestAnimationFrame(update);
    }

    function handleMotionChange(event) {
      if (event.matches) {
        showAll();
      }
    }

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', handleMotionChange);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(handleMotionChange);
    }

    if (reduceMotion.matches || !steps.length) return;
    section.classList.add('rs-seq-armed');

    var observer = new IntersectionObserver(function (entries) {
      nearby = entries[0].isIntersecting;
      if (nearby) requestUpdate();
    }, { rootMargin: '150% 0px' });

    observer.observe(section);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  for (var index = 0; index < sections.length; index += 1) {
    init(sections[index]);
  }
}());
